export default {
  Rewards: {
    _tag: 'CSidebarNavItem',
    name: 'Rewards',
    phrase: 'nav-rewards',
    to: '/rewards',
    order: 3,
    icon: 'fa-regular fa-award',
   roles: ['Admin','Sub Admin'],
  },
}
